import { getCurrentInstance, computed, ref } from "vue";

const token = ref<string | null>(null);

export function useKeycloak() {
  const app = getCurrentInstance();
  const keycloak = computed(
    () => app?.appContext.config.globalProperties.$keycloak
  );

  const isAuthenticated = computed(
    () => keycloak.value?.authenticated ?? false
  );

  // Call this anytime you know the token might have changed
  const syncToken = () => {
    if (keycloak.value?.token) {
      token.value = keycloak.value.token;
    }
  };

  const updateToken = async (minValidity: number) => {
    if (!keycloak.value) return false;

    try {
      const refreshed = await keycloak.value.updateToken(minValidity);
      if (refreshed) {
        console.log("🔁 Token refreshed manually");
        syncToken();
      }
      return refreshed;
    } catch (err) {
      console.error("❌ Error refreshing token:", err);
      return false;
    }
  };

  // Optionally sync once on load
  if (keycloak.value?.token) {
    token.value = keycloak.value.token;
  }

  return {
    keycloak,
    token,
    isAuthenticated,
    login: () => keycloak.value?.login(),
    logout: () => keycloak.value?.logout(),
    updateToken,
    hasRealmRole: (role: string) => keycloak.value?.hasRealmRole(role) ?? false,
    syncToken,
  };
}
